import { StackProps, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import useCustomToast from "../../lib/useCustomToast";
import { useDarkWhiteColor } from "../../themes/colors";
import { axiosPublic } from "../../utils/AxiosInstance";
import { formatToRupiah } from "../../utils/helperFunction";
import { CardSkeleton } from "../skeleton/CardSkeleton";

interface Props extends StackProps {}

const PricePremiumCard = ({ ...rest }: Props) => {
  const [data, setData] = useState<string>("0");
  const [loaded, setLoaded] = useState<boolean>(false);
  const bgBnw = useDarkWhiteColor();
  const toast = useCustomToast();

  useEffect(() => {
    axiosPublic
      .get(`/v1/premiumbenefit/setting`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message,
        });
      })
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded) {
    return <CardSkeleton row={1} height={40} />;
  }

  return (
    <VStack w={"full"} mt={8} bg={bgBnw} align={"stretch"}>
      <Text textStyle={"b-reg-sb"}>Harga Akun Premium 1 Tahun</Text>

      <Text textStyle={"h-title"} color={"red.400"}>
        {formatToRupiah(parseInt(data))}
      </Text>
    </VStack>
  );
};

export default PricePremiumCard;
